import React, { useEffect } from "react";
import ReactGA4 from "react-ga4";

import { shopId } from "src/config";
import { useAuth } from "src/providers/Auth";

export default function WithTracker({ children, ga }) {
  const { auth } = useAuth();
  const lineId = auth.userId;

  useEffect(() => {
    if (!lineId || !ga) return;
    const page = `/shop/${shopId}/user/${lineId}/action/${ga}`;
    const qs = new URLSearchParams(window.location.search);

    ReactGA4.set({
      userId: `shop/${shopId}/user/${lineId}`,
      referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
      title: ga,
      campaignSource: qs.get("utm_source"),
      campaignMedium: qs.get("utm_medium"),
      campaignName: qs.get("utm_campaign"),
      campaignContent: qs.get("utm_content"),
      campaignKeyword: qs.get("utm_term"),
      campaignId: qs.get("utm_id"),
    });
    ReactGA4.send({ hitType: "pageview", page, title: ga });
  }, [lineId, ga]);

  return <>{children}</>;
}
